module.exports = __webpack_public_path__ + "static/media/audit_log_active.12320ec4.svg";